import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import { Typography } from 'app/components';

import '../RemoveModal/RemoveModal.scss';

interface AffectedTagsModalProps {
  show: boolean;
  affectedCount: number;
  itemLabel: string;
  onClose: () => void;
  onGoToTags: () => void;
}

export const AffectedTagsModal = ({ show, affectedCount, itemLabel, onClose, onGoToTags }: AffectedTagsModalProps) => {
  const { t } = useTranslation(['common', 'tag']);

  return (
    <Modal show={show} centered dialogClassName="remove-modal-dialog" contentClassName="remove-modal">
      <Modal.Body className="remove-modal__content">
        <Typography variant="body-8" fontWeight="semibold">
          {t('tag:affected.title')}
        </Typography>

        <Typography variant="body-7">{t('tag:affected.description', { count: affectedCount, label: itemLabel })}</Typography>

        <div className="remove-modal__actions">
          <button className="btn btn-primary" onClick={onGoToTags}>
            {t('tag:affected.go.to.tags')}
          </button>

          <button className="btn btn-secondary" onClick={onClose}>
            {t('common:cancel')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
